export default __webpack_public_path__ + "assets/images/355f73582f8e0bfef714b8757f870754.svg";